
import apiClient from "../utils/apiClient";

// Login API (multipart/form-data)
export const loginApi = async (email, password) => {
  try {
    const formData = new FormData();
    formData.append("email", email);
    formData.append("password", password);

    const response = await apiClient.post("/auth/login/", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("Login API error:", error);

    throw {
      status: error.response?.status,
      message:
        error.response?.data?.message ||
        error.response?.data?.detail ||
        "Login failed. Please try again.",
      data: error.response?.data || null,
    };
  }
};


// Refresh token API
export const refreshTokenApi = async (refreshToken) => {
  try {
    const response = await apiClient.post("/auth/token/refresh/", {
      refresh: refreshToken,
    });

    return response.data;
  } catch (error) {
    console.error("Refresh token error:", error);

    throw {
      status: error.response?.status,
      message:
        error.response?.data?.message ||
        error.response?.data?.detail ||
        "Session expired. Please login again.",
      data: error.response?.data || null,
    };
  }
};
